import createReactComponent from '../createReactComponent';
export default createReactComponent('lane', 'IconLane', [
  ['path', { d: 'M4 6v13', key: 'svg-0' }],
  ['path', { d: 'M20 6v13', key: 'svg-1' }],
]);
